export const getIsEditing = () => new URLSearchParams(window.location.search).get('tab') !== 'adCampaignBuilder';
